// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleMainContent_wrapper__Pil_m","contentSection":"ArticleMainContent_contentSection__BvJUB"};